/**
 * ![grey 50](https://mui.com/static/colors-preview/grey-50-24x24.png) ![grey 100](https://mui.com/static/colors-preview/grey-100-24x24.png) ![grey 200](https://mui.com/static/colors-preview/grey-200-24x24.png) ![grey 300](https://mui.com/static/colors-preview/grey-300-24x24.png) ![grey 400](https://mui.com/static/colors-preview/grey-400-24x24.png) ![grey 500](https://mui.com/static/colors-preview/grey-500-24x24.png) ![grey 600](https://mui.com/static/colors-preview/grey-600-24x24.png) ![grey 700](https://mui.com/static/colors-preview/grey-700-24x24.png) ![grey 800](https://mui.com/static/colors-preview/grey-800-24x24.png) ![grey 900](https://mui.com/static/colors-preview/grey-900-24x24.png) ![grey A100](https://mui.com/static/colors-preview/grey-A100-24x24.png) ![grey A200](https://mui.com/static/colors-preview/grey-A200-24x24.png) ![grey A400](https://mui.com/static/colors-preview/grey-A400-24x24.png) ![grey A700](https://mui.com/static/colors-preview/grey-A700-24x24.png)
 */
const grey = {
  /**
   * Preview: ![grey 50](https://mui.com/static/colors-preview/grey-50-24x24.png)
   */
  50: '#fafafa',
  /**
   * Preview: ![grey 100](https://mui.com/static/colors-preview/grey-100-24x24.png)
   */
  100: '#f5f5f5',
  /**
   * Preview: ![grey 200](https://mui.com/static/colors-preview/grey-200-24x24.png)
   */
  200: '#eeeeee',
  /**
   * Preview: ![grey 300](https://mui.com/static/colors-preview/grey-300-24x24.png)
   */
  300: '#e0e0e0',
  /**
   * Preview: ![grey 400](https://mui.com/static/colors-preview/grey-400-24x24.png)
   */
  400: '#bdbdbd',
  /**
   * Preview: ![grey 500](https://mui.com/static/colors-preview/grey-500-24x24.png)
   */
  500: '#9e9e9e',
  /**
   * Preview: ![grey 600](https://mui.com/static/colors-preview/grey-600-24x24.png)
   */
  600: '#757575',
  /**
   * Preview: ![grey 700](https://mui.com/static/colors-preview/grey-700-24x24.png)
   */
  700: '#616161',
  /**
   * Preview: ![grey 800](https://mui.com/static/colors-preview/grey-800-24x24.png)
   */
  800: '#424242',
  /**
   * Preview: ![grey 900](https://mui.com/static/colors-preview/grey-900-24x24.png)
   */
  900: '#212121',
  /**
   * Preview: ![grey A100](https://mui.com/static/colors-preview/grey-A100-24x24.png)
   */
  A100: '#f5f5f5',
  /**
   * Preview: ![grey A200](https://mui.com/static/colors-preview/grey-A200-24x24.png)
   */
  A200: '#eeeeee',
  /**
   * Preview: ![grey A400](https://mui.com/static/colors-preview/grey-A400-24x24.png)
   */
  A400: '#bdbdbd',
  /**
   * Preview: ![grey A700](https://mui.com/static/colors-preview/grey-A700-24x24.png)
   */
  A700: '#616161',
} as const;

export default grey;
